<template>
  <Doughnut :chartData="chartData" :chartOptions="chartOptions" />
</template>

<script>
  import { Doughnut } from 'vue-chartjs'
  import { Chart as ChartJS, Title } from 'chart.js'

  ChartJS.register(Title)
  export default {
    name: 'DoughChart',
    components: {
      Doughnut,
    },
    props: {
      value: {
        type: Array,
      },
    },
    watch: {
      value: {
        handler(val) {
          this.chartData = {
            datasets: [
              {
                backgroundColor: ['#D9BD8C', '#EAE7DE'],
                data: val,
                cutout: '60%',
              },
            ],
          }
        },
      },
    },
    data() {
      return {
        chartData: {
          datasets: [
            {
              backgroundColor: ['#D9BD8C', '#EAE7DE'],
              data: [0, 0],
              cutout: '60%',
            },
          ],
        },
        chartOptions: {
          plugins: {
            tooltip: {
              enabled: false,
            },
          },
          borderWidth: 0,
          layout: {
            padding: {
              top: -10,
            },
          },
        },
      }
    },
  }
</script>

<style lang="less" scoped></style>
